// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Consent ledger — same roster-board language as User Management. */
.cl-board {
  --cl-pine: var(--brand-primary, #0877bc);
  --cl-ink: var(--brand-primary-dark, var(--brand-primary, #0877bc));
  --cl-line: color-mix(in srgb, var(--border-color, #e2e8f0) 70%, var(--brand-primary, #0877bc));
  --cl-muted: var(--text-secondary, #64748b);
  --cl-ok: #0f9f6e;
  --cl-warn: #d97706;
  --cl-app: #0284c7;
  --cl-parent: #7c3aed;
  --cl-danger: #dc2626;
  --cl-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --cl-display: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  --cl-body: "IBM Plex Sans", Poppins, system-ui, sans-serif;

  position: relative;
  isolation: isolate;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0 auto;
  padding:
    max(0.75rem, env(safe-area-inset-top, 0px))
    max(1rem, env(safe-area-inset-right, 0px))
    calc(1.75rem + env(safe-area-inset-bottom, 0px))
    max(1rem, env(safe-area-inset-left, 0px));
  color: var(--text-color);
  font-family: var(--cl-body);
}

.cl-board *,
.cl-board *::before,
.cl-board *::after {
  box-sizing: border-box;
}

.cl-board__glow {
  pointer-events: none;
  position: absolute;
  z-index: -1;
  inset: -6% -12% auto;
  height: 160px;
  opacity: 0.75;
  background:
    radial-gradient(50% 70% at 6% 20%, color-mix(in srgb, var(--cl-pine) 16%, transparent) 0%, transparent 70%),
    radial-gradient(36% 50% at 94% 0%, color-mix(in srgb, var(--cl-parent) 10%, transparent) 0%, transparent 68%);
}

.cl-hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.85rem 1.25rem;
  margin-bottom: 1rem;
}

.cl-hero__copy {
  min-width: 0;
  max-width: 44rem;
}

.cl-hero__kicker {
  margin: 0 0 0.2rem;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--cl-muted);
}

.cl-hero__title {
  margin: 0;
  font-family: var(--cl-display);
  font-size: clamp(1.85rem, 3.2vw, 2.55rem);
  font-weight: 700;
  line-height: 0.95;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--cl-ink);
}

.cl-hero__sub {
  margin: 0.45rem 0 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: var(--cl-muted);
  max-width: 40rem;
}

.cl-hero__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.cl-stat {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 5.5rem;
  max-width: 8.5rem;
  padding: 0.55rem 0.75rem;
  border-radius: 12px;
  border: 1px solid var(--cl-line);
  background: color-mix(in srgb, var(--surface-color, #fff) 88%, transparent);
  backdrop-filter: blur(8px);
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 0.18s var(--cl-ease),
    box-shadow 0.18s var(--cl-ease),
    transform 0.18s var(--cl-ease),
    background 0.18s var(--cl-ease);
}

.cl-stat:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px color-mix(in srgb, var(--cl-pine) 12%, transparent);
}

.cl-stat:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--cl-pine) 55%, transparent);
  outline-offset: 2px;
}

.cl-stat.is-active {
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cl-pine) 35%, transparent);
  background: color-mix(in srgb, var(--cl-pine) 10%, var(--surface-color, #fff));
}

.cl-stat--ok.is-active {
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cl-ok) 45%, transparent);
  background: color-mix(in srgb, var(--cl-ok) 12%, var(--surface-color, #fff));
}

.cl-stat--warn.is-active {
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cl-warn) 45%, transparent);
  background: color-mix(in srgb, var(--cl-warn) 12%, var(--surface-color, #fff));
}

.cl-stat--app.is-active {
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cl-app) 45%, transparent);
  background: color-mix(in srgb, var(--cl-app) 12%, var(--surface-color, #fff));
}

.cl-stat--parent.is-active {
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cl-parent) 45%, transparent);
  background: color-mix(in srgb, var(--cl-parent) 12%, var(--surface-color, #fff));
}

.cl-stat--ok {
  border-color: color-mix(in srgb, var(--cl-ok) 35%, var(--cl-line));
}

.cl-stat--warn {
  border-color: color-mix(in srgb, var(--cl-warn) 35%, var(--cl-line));
}

.cl-stat--app {
  border-color: color-mix(in srgb, var(--cl-app) 35%, var(--cl-line));
}

.cl-stat--parent {
  border-color: color-mix(in srgb, var(--cl-parent) 35%, var(--cl-line));
}

.cl-stat__value {
  font-family: var(--cl-display);
  font-size: 1.55rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
  color: var(--cl-pine);
}

.cl-stat__label {
  margin-top: 0.25rem;
  font-size: 0.64rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--cl-muted);
  line-height: 1.25;
}

.cl-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.9rem;
  padding: 0.7rem;
  border-radius: 16px;
  border: 1px solid var(--cl-line);
  background:
    linear-gradient(
      135deg,
      color-mix(in srgb, var(--cl-pine) 6%, transparent),
      transparent 55%
    ),
    color-mix(in srgb, var(--surface-color, #fff) 92%, transparent);
}

.cl-search {
  position: relative;
  flex: 1 1 14rem;
  min-width: 0;
}

.cl-search__icon {
  position: absolute;
  left: 0.85rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--cl-muted);
  pointer-events: none;
}

.cl-search__input {
  width: 100%;
  height: 2.65rem;
  padding: 0 0.9rem 0 2.35rem;
  border-radius: 999px;
  border: 1px solid var(--cl-line);
  background: var(--bg-color, #fff);
  color: var(--text-color);
  font: 500 0.92rem/1.2 var(--cl-body);
  outline: none;
  transition: border-color 0.2s var(--cl-ease), box-shadow 0.2s var(--cl-ease);
}

.cl-search__input:focus {
  border-color: color-mix(in srgb, var(--cl-pine) 55%, var(--cl-line));
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--cl-pine) 18%, transparent);
}

.cl-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.cl-filter {
  appearance: none;
  min-height: 2.2rem;
  padding: 0.35rem 0.85rem;
  border-radius: 999px;
  border: 1px solid var(--cl-line);
  background: transparent;
  color: var(--cl-muted);
  font: 600 0.78rem/1 var(--cl-body);
  cursor: pointer;
  transition: background 0.18s var(--cl-ease), color 0.18s var(--cl-ease),
    border-color 0.18s var(--cl-ease);
}

.cl-filter.is-active {
  background: var(--cl-pine);
  border-color: var(--cl-pine);
  color: #fff;
}

.cl-error {
  margin: 0 0 0.85rem;
  padding: 0.65rem 0.85rem;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--cl-danger) 35%, transparent);
  background: color-mix(in srgb, var(--cl-danger) 8%, transparent);
  color: var(--cl-danger);
  font-size: 0.88rem;
}

.cl-empty {
  display: grid;
  place-items: center;
  gap: 0.65rem;
  padding: 2.5rem 1rem;
  text-align: center;
  color: var(--cl-muted);
  border-radius: 16px;
  border: 1px dashed var(--cl-line);
}

.cl-empty p {
  margin: 0;
  max-width: 28rem;
  font-size: 0.92rem;
  line-height: 1.45;
}

.cl-list {
  display: grid;
  gap: 0.75rem;
}

.cl-card {
  display: grid;
  gap: 0.85rem;
  padding: 0.95rem 1rem;
  border-radius: 16px;
  border: 1px solid var(--cl-line);
  background: color-mix(in srgb, var(--surface-color, #fff) 94%, transparent);
  transition: border-color 0.2s var(--cl-ease), transform 0.2s var(--cl-ease);
}

.cl-card--gap {
  border-color: color-mix(in srgb, var(--cl-warn) 32%, var(--cl-line));
}

@media (min-width: 900px) {
  .cl-card {
    grid-template-columns: minmax(12rem, 1fr) minmax(0, 2.2fr);
    align-items: start;
  }
}

.cl-card__identity {
  display: flex;
  gap: 0.75rem;
  min-width: 0;
}

.cl-avatar {
  flex: 0 0 auto;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-family: var(--cl-display);
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #fff;
  background: var(--cl-pine);
}

.cl-avatar--adult {
  background: color-mix(in srgb, var(--cl-app) 85%, #0f172a);
}

.cl-avatar--minor {
  background: color-mix(in srgb, var(--cl-parent) 80%, #0f172a);
}

.cl-avatar--unknown {
  background: #64748b;
}

.cl-card__text {
  min-width: 0;
}

.cl-card__name {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--text-color);
}

.cl-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.4rem;
}

.cl-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid var(--cl-line);
  color: var(--cl-muted);
  background: color-mix(in srgb, var(--bg-color, #fff) 70%, transparent);
}

.cl-pill--adult {
  border-color: color-mix(in srgb, var(--cl-app) 35%, var(--cl-line));
  color: var(--cl-app);
}

.cl-pill--minor {
  border-color: color-mix(in srgb, var(--cl-parent) 35%, var(--cl-line));
  color: var(--cl-parent);
}

.cl-pill--app {
  border-color: color-mix(in srgb, var(--cl-app) 40%, var(--cl-line));
  color: var(--cl-app);
}

.cl-pill--parent,
.cl-pill--paper {
  border-color: color-mix(in srgb, var(--cl-parent) 40%, var(--cl-line));
  color: var(--cl-parent);
}

.cl-pill--staff {
  border-color: color-mix(in srgb, var(--cl-ok) 40%, var(--cl-line));
  color: var(--cl-ok);
}

.cl-pill--gap {
  border-color: color-mix(in srgb, var(--cl-warn) 40%, var(--cl-line));
  color: var(--cl-warn);
}

.cl-purposes {
  display: grid;
  gap: 0.5rem;
}

@media (min-width: 700px) {
  .cl-purposes {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.cl-purpose {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.65rem 0.7rem;
  border-radius: 12px;
  border: 1px solid var(--cl-line);
  background: color-mix(in srgb, var(--bg-color, #fff) 80%, transparent);
  min-height: 5.5rem;
}

.cl-purpose.is-on {
  border-color: color-mix(in srgb, var(--cl-ok) 35%, var(--cl-line));
}

.cl-purpose.is-off {
  border-style: dashed;
}

.cl-purpose__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
}

.cl-purpose__label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cl-muted);
}

.cl-purpose__status {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--cl-muted);
}

.cl-purpose__status.is-on {
  color: var(--cl-ok);
}

.cl-purpose__detail {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 0.4rem;
  font-size: 0.75rem;
  color: var(--cl-muted);
  line-height: 1.35;
}

.cl-purpose__doc {
  color: var(--cl-pine);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.cl-purpose__verified {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  color: var(--cl-ok);
  font-weight: 600;
}

.cl-purpose__ref {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.7rem;
}

.cl-purpose__actions {
  margin-top: auto;
  display: flex;
  align-items: center;
  min-height: 1.25rem;
}

.cl-link {
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  color: var(--cl-pine);
  font: 600 0.78rem/1.2 var(--cl-body);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.cl-link--strong {
  text-decoration: none;
  color: #fff;
  background: var(--cl-pine);
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
}

.cl-hint {
  font-size: 0.72rem;
  color: var(--cl-muted);
  font-style: italic;
}

.cl-modal {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: grid;
  place-items: center;
  padding: 1rem;
}

.cl-modal__backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: color-mix(in srgb, #0f172a 48%, transparent);
  cursor: pointer;
}

.cl-modal__panel {
  position: relative;
  z-index: 1;
  width: min(30rem, 100%);
  max-height: min(92vh, 48rem);
  overflow: auto;
  display: grid;
  gap: 0.85rem;
  padding: 1.15rem 1.2rem 1.25rem;
  border-radius: 18px;
  border: 1px solid var(--cl-line);
  background: var(--surface-color, #fff);
  box-shadow: 0 24px 60px color-mix(in srgb, #0f172a 28%, transparent);
  animation: cl-rise 0.28s var(--cl-ease);
}

@keyframes cl-rise {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cl-modal__panel {
    animation: none;
  }
}

.cl-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.cl-modal__kicker {
  margin: 0;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--cl-muted);
}

.cl-modal__title {
  margin: 0.15rem 0 0;
  font-family: var(--cl-display);
  font-size: 1.55rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--cl-ink);
  line-height: 1;
}

.cl-modal__close {
  appearance: none;
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 999px;
  border: 1px solid var(--cl-line);
  background: transparent;
  color: var(--cl-muted);
  display: grid;
  place-items: center;
  cursor: pointer;
}

.cl-modal__help {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: var(--cl-muted);
}

.cl-field {
  display: grid;
  gap: 0.35rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-color);
}

.cl-field em {
  font-weight: 400;
  color: var(--cl-muted);
  font-style: normal;
}

.cl-field input,
.cl-field select {
  width: 100%;
  min-height: 2.55rem;
  padding: 0.5rem 0.7rem;
  border-radius: 10px;
  border: 1px solid var(--cl-line);
  background: var(--bg-color, #fff);
  color: var(--text-color);
  font: 500 0.9rem/1.2 var(--cl-body);
}

.cl-field input:focus,
.cl-field select:focus {
  outline: none;
  border-color: color-mix(in srgb, var(--cl-pine) 55%, var(--cl-line));
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--cl-pine) 18%, transparent);
}

.cl-drop {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 0.9rem;
  border-radius: 12px;
  border: 1px dashed color-mix(in srgb, var(--cl-pine) 45%, var(--cl-line));
  background: color-mix(in srgb, var(--cl-pine) 6%, transparent);
  color: var(--cl-pine);
  cursor: pointer;
}

.cl-drop strong {
  display: block;
  font-size: 0.88rem;
  color: var(--text-color);
}

.cl-drop span {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--cl-muted);
}

.cl-drop input[type="file"] {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.cl-error--modal {
  margin: 0;
}

.cl-purpose-picks {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}

.cl-purpose-picks legend {
  padding: 0;
  margin-bottom: 0.35rem;
}

.cl-check {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 2.5rem;
  padding: 0.35rem 0.7rem;
  border-radius: 10px;
  border: 1px solid var(--cl-line);
  font-weight: 500;
  cursor: pointer;
}

.cl-check + .cl-check {
  margin-top: 0.35rem;
}

.cl-check input,
.cl-validate input {
  width: 1.1rem;
  height: 1.1rem;
  flex: none;
  accent-color: var(--cl-pine);
}

.cl-check em {
  margin-left: auto;
  font-size: 0.75rem;
}

.cl-check.is-done {
  cursor: default;
  border-color: color-mix(in srgb, var(--cl-ok) 35%, var(--cl-line));
  background: color-mix(in srgb, var(--cl-ok) 6%, transparent);
}

.cl-validate {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.75rem 0.85rem;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--cl-ok) 40%, var(--cl-line));
  background: color-mix(in srgb, var(--cl-ok) 7%, transparent);
  font-size: 0.85rem;
  line-height: 1.4;
  cursor: pointer;
}

.cl-validate input {
  margin-top: 0.1rem;
}

.cl-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.25rem;
}

.cl-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.55rem;
  padding: 0.55rem 1.1rem;
  border-radius: 999px;
  border: 1px solid transparent;
  font: 600 0.85rem/1 var(--cl-body);
  cursor: pointer;
  transition: transform 0.18s var(--cl-ease), opacity 0.18s var(--cl-ease);
}

.cl-btn:disabled {
  opacity: 0.6;
  cursor: wait;
}

.cl-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.cl-btn--primary {
  background: var(--cl-pine);
  color: #fff;
}

.cl-btn--ghost {
  background: transparent;
  border-color: var(--cl-line);
  color: var(--cl-muted);
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/ConsentLedger.css"],"names":[],"mappings":"AAEA,oEAAoE;AACpE;EACE,wCAAwC;EACxC,kEAAkE;EAClE,8FAA8F;EAC9F,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,yCAAyC;EACzC,oEAAoE;EACpE,0DAA0D;;EAE1D,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd;;;;6CAI2C;EAC3C,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb;;iHAE+G;AACjH;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;EAChC,2EAA2E;EAC3E,0BAA0B;EAC1B,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf;;;;mCAIiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,0EAA0E;AAC5E;;AAEA;EACE,sEAAsE;EACtE,mBAAmB;AACrB;;AAEA;EACE,yEAAyE;EACzE,8EAA8E;AAChF;;AAEA;EACE,uEAAuE;EACvE,4EAA4E;AAC9E;;AAEA;EACE,yEAAyE;EACzE,8EAA8E;AAChF;;AAEA;EACE,wEAAwE;EACxE,6EAA6E;AAC/E;;AAEA;EACE,2EAA2E;EAC3E,gFAAgF;AAClF;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC;;;;;;mEAMiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;EACxB,oCAAoC;EACpC,aAAa;EACb,4EAA4E;AAC9E;;AAEA;EACE,oEAAoE;EACpE,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;EACf;qCACmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,uEAAuE;EACvE,gEAAgE;EAChE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,2EAA2E;EAC3E,2EAA2E;AAC7E;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE;IACE,0DAA0D;IAC1D,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,sEAAsE;AACxE;;AAEA;EACE,mEAAmE;EACnE,oBAAoB;AACtB;;AAEA;EACE,sEAAsE;EACtE,uBAAuB;AACzB;;AAEA;EACE,mEAAmE;EACnE,oBAAoB;AACtB;;AAEA;;EAEE,sEAAsE;EACtE,uBAAuB;AACzB;;AAEA;EACE,kEAAkE;EAClE,mBAAmB;AACrB;;AAEA;EACE,oEAAoE;EACpE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,sEAAsE;EACtE,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,oCAAoC;EACpC,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wDAAwD;EACxD,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,oEAAoE;EACpE,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;EACb,oEAAoE;EACpE,yEAAyE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,yEAAyE;EACzE,8DAA8D;EAC9D,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kEAAkE;EAClE,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,sEAAsE;EACtE,4DAA4D;EAC5D,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,wEAAwE;AAC1E;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;AACxB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap\");\n\n/* Consent ledger — same roster-board language as User Management. */\n.cl-board {\n  --cl-pine: var(--brand-primary, #0877bc);\n  --cl-ink: var(--brand-primary-dark, var(--brand-primary, #0877bc));\n  --cl-line: color-mix(in srgb, var(--border-color, #e2e8f0) 70%, var(--brand-primary, #0877bc));\n  --cl-muted: var(--text-secondary, #64748b);\n  --cl-ok: #0f9f6e;\n  --cl-warn: #d97706;\n  --cl-app: #0284c7;\n  --cl-parent: #7c3aed;\n  --cl-danger: #dc2626;\n  --cl-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --cl-display: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  --cl-body: \"IBM Plex Sans\", Poppins, system-ui, sans-serif;\n\n  position: relative;\n  isolation: isolate;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0 auto;\n  padding:\n    max(0.75rem, env(safe-area-inset-top, 0px))\n    max(1rem, env(safe-area-inset-right, 0px))\n    calc(1.75rem + env(safe-area-inset-bottom, 0px))\n    max(1rem, env(safe-area-inset-left, 0px));\n  color: var(--text-color);\n  font-family: var(--cl-body);\n}\n\n.cl-board *,\n.cl-board *::before,\n.cl-board *::after {\n  box-sizing: border-box;\n}\n\n.cl-board__glow {\n  pointer-events: none;\n  position: absolute;\n  z-index: -1;\n  inset: -6% -12% auto;\n  height: 160px;\n  opacity: 0.75;\n  background:\n    radial-gradient(50% 70% at 6% 20%, color-mix(in srgb, var(--cl-pine) 16%, transparent) 0%, transparent 70%),\n    radial-gradient(36% 50% at 94% 0%, color-mix(in srgb, var(--cl-parent) 10%, transparent) 0%, transparent 68%);\n}\n\n.cl-hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 0.85rem 1.25rem;\n  margin-bottom: 1rem;\n}\n\n.cl-hero__copy {\n  min-width: 0;\n  max-width: 44rem;\n}\n\n.cl-hero__kicker {\n  margin: 0 0 0.2rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--cl-muted);\n}\n\n.cl-hero__title {\n  margin: 0;\n  font-family: var(--cl-display);\n  font-size: clamp(1.85rem, 3.2vw, 2.55rem);\n  font-weight: 700;\n  line-height: 0.95;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--cl-ink);\n}\n\n.cl-hero__sub {\n  margin: 0.45rem 0 0;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: var(--cl-muted);\n  max-width: 40rem;\n}\n\n.cl-hero__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.cl-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 5.5rem;\n  max-width: 8.5rem;\n  padding: 0.55rem 0.75rem;\n  border-radius: 12px;\n  border: 1px solid var(--cl-line);\n  background: color-mix(in srgb, var(--surface-color, #fff) 88%, transparent);\n  backdrop-filter: blur(8px);\n  font: inherit;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    border-color 0.18s var(--cl-ease),\n    box-shadow 0.18s var(--cl-ease),\n    transform 0.18s var(--cl-ease),\n    background 0.18s var(--cl-ease);\n}\n\n.cl-stat:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px color-mix(in srgb, var(--cl-pine) 12%, transparent);\n}\n\n.cl-stat:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--cl-pine) 55%, transparent);\n  outline-offset: 2px;\n}\n\n.cl-stat.is-active {\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cl-pine) 35%, transparent);\n  background: color-mix(in srgb, var(--cl-pine) 10%, var(--surface-color, #fff));\n}\n\n.cl-stat--ok.is-active {\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cl-ok) 45%, transparent);\n  background: color-mix(in srgb, var(--cl-ok) 12%, var(--surface-color, #fff));\n}\n\n.cl-stat--warn.is-active {\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cl-warn) 45%, transparent);\n  background: color-mix(in srgb, var(--cl-warn) 12%, var(--surface-color, #fff));\n}\n\n.cl-stat--app.is-active {\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cl-app) 45%, transparent);\n  background: color-mix(in srgb, var(--cl-app) 12%, var(--surface-color, #fff));\n}\n\n.cl-stat--parent.is-active {\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cl-parent) 45%, transparent);\n  background: color-mix(in srgb, var(--cl-parent) 12%, var(--surface-color, #fff));\n}\n\n.cl-stat--ok {\n  border-color: color-mix(in srgb, var(--cl-ok) 35%, var(--cl-line));\n}\n\n.cl-stat--warn {\n  border-color: color-mix(in srgb, var(--cl-warn) 35%, var(--cl-line));\n}\n\n.cl-stat--app {\n  border-color: color-mix(in srgb, var(--cl-app) 35%, var(--cl-line));\n}\n\n.cl-stat--parent {\n  border-color: color-mix(in srgb, var(--cl-parent) 35%, var(--cl-line));\n}\n\n.cl-stat__value {\n  font-family: var(--cl-display);\n  font-size: 1.55rem;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: 0.02em;\n  color: var(--cl-pine);\n}\n\n.cl-stat__label {\n  margin-top: 0.25rem;\n  font-size: 0.64rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--cl-muted);\n  line-height: 1.25;\n}\n\n.cl-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem;\n  margin-bottom: 0.9rem;\n  padding: 0.7rem;\n  border-radius: 16px;\n  border: 1px solid var(--cl-line);\n  background:\n    linear-gradient(\n      135deg,\n      color-mix(in srgb, var(--cl-pine) 6%, transparent),\n      transparent 55%\n    ),\n    color-mix(in srgb, var(--surface-color, #fff) 92%, transparent);\n}\n\n.cl-search {\n  position: relative;\n  flex: 1 1 14rem;\n  min-width: 0;\n}\n\n.cl-search__icon {\n  position: absolute;\n  left: 0.85rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--cl-muted);\n  pointer-events: none;\n}\n\n.cl-search__input {\n  width: 100%;\n  height: 2.65rem;\n  padding: 0 0.9rem 0 2.35rem;\n  border-radius: 999px;\n  border: 1px solid var(--cl-line);\n  background: var(--bg-color, #fff);\n  color: var(--text-color);\n  font: 500 0.92rem/1.2 var(--cl-body);\n  outline: none;\n  transition: border-color 0.2s var(--cl-ease), box-shadow 0.2s var(--cl-ease);\n}\n\n.cl-search__input:focus {\n  border-color: color-mix(in srgb, var(--cl-pine) 55%, var(--cl-line));\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--cl-pine) 18%, transparent);\n}\n\n.cl-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.cl-filter {\n  appearance: none;\n  min-height: 2.2rem;\n  padding: 0.35rem 0.85rem;\n  border-radius: 999px;\n  border: 1px solid var(--cl-line);\n  background: transparent;\n  color: var(--cl-muted);\n  font: 600 0.78rem/1 var(--cl-body);\n  cursor: pointer;\n  transition: background 0.18s var(--cl-ease), color 0.18s var(--cl-ease),\n    border-color 0.18s var(--cl-ease);\n}\n\n.cl-filter.is-active {\n  background: var(--cl-pine);\n  border-color: var(--cl-pine);\n  color: #fff;\n}\n\n.cl-error {\n  margin: 0 0 0.85rem;\n  padding: 0.65rem 0.85rem;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--cl-danger) 35%, transparent);\n  background: color-mix(in srgb, var(--cl-danger) 8%, transparent);\n  color: var(--cl-danger);\n  font-size: 0.88rem;\n}\n\n.cl-empty {\n  display: grid;\n  place-items: center;\n  gap: 0.65rem;\n  padding: 2.5rem 1rem;\n  text-align: center;\n  color: var(--cl-muted);\n  border-radius: 16px;\n  border: 1px dashed var(--cl-line);\n}\n\n.cl-empty p {\n  margin: 0;\n  max-width: 28rem;\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.cl-list {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.cl-card {\n  display: grid;\n  gap: 0.85rem;\n  padding: 0.95rem 1rem;\n  border-radius: 16px;\n  border: 1px solid var(--cl-line);\n  background: color-mix(in srgb, var(--surface-color, #fff) 94%, transparent);\n  transition: border-color 0.2s var(--cl-ease), transform 0.2s var(--cl-ease);\n}\n\n.cl-card--gap {\n  border-color: color-mix(in srgb, var(--cl-warn) 32%, var(--cl-line));\n}\n\n@media (min-width: 900px) {\n  .cl-card {\n    grid-template-columns: minmax(12rem, 1fr) minmax(0, 2.2fr);\n    align-items: start;\n  }\n}\n\n.cl-card__identity {\n  display: flex;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.cl-avatar {\n  flex: 0 0 auto;\n  width: 2.75rem;\n  height: 2.75rem;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  font-family: var(--cl-display);\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #fff;\n  background: var(--cl-pine);\n}\n\n.cl-avatar--adult {\n  background: color-mix(in srgb, var(--cl-app) 85%, #0f172a);\n}\n\n.cl-avatar--minor {\n  background: color-mix(in srgb, var(--cl-parent) 80%, #0f172a);\n}\n\n.cl-avatar--unknown {\n  background: #64748b;\n}\n\n.cl-card__text {\n  min-width: 0;\n}\n\n.cl-card__name {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--text-color);\n}\n\n.cl-card__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-top: 0.4rem;\n}\n\n.cl-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  border: 1px solid var(--cl-line);\n  color: var(--cl-muted);\n  background: color-mix(in srgb, var(--bg-color, #fff) 70%, transparent);\n}\n\n.cl-pill--adult {\n  border-color: color-mix(in srgb, var(--cl-app) 35%, var(--cl-line));\n  color: var(--cl-app);\n}\n\n.cl-pill--minor {\n  border-color: color-mix(in srgb, var(--cl-parent) 35%, var(--cl-line));\n  color: var(--cl-parent);\n}\n\n.cl-pill--app {\n  border-color: color-mix(in srgb, var(--cl-app) 40%, var(--cl-line));\n  color: var(--cl-app);\n}\n\n.cl-pill--parent,\n.cl-pill--paper {\n  border-color: color-mix(in srgb, var(--cl-parent) 40%, var(--cl-line));\n  color: var(--cl-parent);\n}\n\n.cl-pill--staff {\n  border-color: color-mix(in srgb, var(--cl-ok) 40%, var(--cl-line));\n  color: var(--cl-ok);\n}\n\n.cl-pill--gap {\n  border-color: color-mix(in srgb, var(--cl-warn) 40%, var(--cl-line));\n  color: var(--cl-warn);\n}\n\n.cl-purposes {\n  display: grid;\n  gap: 0.5rem;\n}\n\n@media (min-width: 700px) {\n  .cl-purposes {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.cl-purpose {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.65rem 0.7rem;\n  border-radius: 12px;\n  border: 1px solid var(--cl-line);\n  background: color-mix(in srgb, var(--bg-color, #fff) 80%, transparent);\n  min-height: 5.5rem;\n}\n\n.cl-purpose.is-on {\n  border-color: color-mix(in srgb, var(--cl-ok) 35%, var(--cl-line));\n}\n\n.cl-purpose.is-off {\n  border-style: dashed;\n}\n\n.cl-purpose__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.4rem;\n}\n\n.cl-purpose__label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--cl-muted);\n}\n\n.cl-purpose__status {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--cl-muted);\n}\n\n.cl-purpose__status.is-on {\n  color: var(--cl-ok);\n}\n\n.cl-purpose__detail {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem 0.4rem;\n  font-size: 0.75rem;\n  color: var(--cl-muted);\n  line-height: 1.35;\n}\n\n.cl-purpose__doc {\n  color: var(--cl-pine);\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.cl-purpose__verified {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  color: var(--cl-ok);\n  font-weight: 600;\n}\n\n.cl-purpose__ref {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 0.7rem;\n}\n\n.cl-purpose__actions {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  min-height: 1.25rem;\n}\n\n.cl-link {\n  appearance: none;\n  background: none;\n  border: 0;\n  padding: 0;\n  color: var(--cl-pine);\n  font: 600 0.78rem/1.2 var(--cl-body);\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.cl-link--strong {\n  text-decoration: none;\n  color: #fff;\n  background: var(--cl-pine);\n  padding: 0.35rem 0.65rem;\n  border-radius: 999px;\n}\n\n.cl-hint {\n  font-size: 0.72rem;\n  color: var(--cl-muted);\n  font-style: italic;\n}\n\n.cl-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: grid;\n  place-items: center;\n  padding: 1rem;\n}\n\n.cl-modal__backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  background: color-mix(in srgb, #0f172a 48%, transparent);\n  cursor: pointer;\n}\n\n.cl-modal__panel {\n  position: relative;\n  z-index: 1;\n  width: min(30rem, 100%);\n  max-height: min(92vh, 48rem);\n  overflow: auto;\n  display: grid;\n  gap: 0.85rem;\n  padding: 1.15rem 1.2rem 1.25rem;\n  border-radius: 18px;\n  border: 1px solid var(--cl-line);\n  background: var(--surface-color, #fff);\n  box-shadow: 0 24px 60px color-mix(in srgb, #0f172a 28%, transparent);\n  animation: cl-rise 0.28s var(--cl-ease);\n}\n\n@keyframes cl-rise {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cl-modal__panel {\n    animation: none;\n  }\n}\n\n.cl-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.cl-modal__kicker {\n  margin: 0;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--cl-muted);\n}\n\n.cl-modal__title {\n  margin: 0.15rem 0 0;\n  font-family: var(--cl-display);\n  font-size: 1.55rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--cl-ink);\n  line-height: 1;\n}\n\n.cl-modal__close {\n  appearance: none;\n  width: 2.1rem;\n  height: 2.1rem;\n  border-radius: 999px;\n  border: 1px solid var(--cl-line);\n  background: transparent;\n  color: var(--cl-muted);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n}\n\n.cl-modal__help {\n  margin: 0;\n  font-size: 0.88rem;\n  line-height: 1.4;\n  color: var(--cl-muted);\n}\n\n.cl-field {\n  display: grid;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-color);\n}\n\n.cl-field em {\n  font-weight: 400;\n  color: var(--cl-muted);\n  font-style: normal;\n}\n\n.cl-field input,\n.cl-field select {\n  width: 100%;\n  min-height: 2.55rem;\n  padding: 0.5rem 0.7rem;\n  border-radius: 10px;\n  border: 1px solid var(--cl-line);\n  background: var(--bg-color, #fff);\n  color: var(--text-color);\n  font: 500 0.9rem/1.2 var(--cl-body);\n}\n\n.cl-field input:focus,\n.cl-field select:focus {\n  outline: none;\n  border-color: color-mix(in srgb, var(--cl-pine) 55%, var(--cl-line));\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--cl-pine) 18%, transparent);\n}\n\n.cl-drop {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.85rem 0.9rem;\n  border-radius: 12px;\n  border: 1px dashed color-mix(in srgb, var(--cl-pine) 45%, var(--cl-line));\n  background: color-mix(in srgb, var(--cl-pine) 6%, transparent);\n  color: var(--cl-pine);\n  cursor: pointer;\n}\n\n.cl-drop strong {\n  display: block;\n  font-size: 0.88rem;\n  color: var(--text-color);\n}\n\n.cl-drop span {\n  display: block;\n  margin-top: 0.15rem;\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: var(--cl-muted);\n}\n\n.cl-drop input[type=\"file\"] {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.cl-error--modal {\n  margin: 0;\n}\n\n.cl-purpose-picks {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  min-width: 0;\n}\n\n.cl-purpose-picks legend {\n  padding: 0;\n  margin-bottom: 0.35rem;\n}\n\n.cl-check {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  min-height: 2.5rem;\n  padding: 0.35rem 0.7rem;\n  border-radius: 10px;\n  border: 1px solid var(--cl-line);\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.cl-check + .cl-check {\n  margin-top: 0.35rem;\n}\n\n.cl-check input,\n.cl-validate input {\n  width: 1.1rem;\n  height: 1.1rem;\n  flex: none;\n  accent-color: var(--cl-pine);\n}\n\n.cl-check em {\n  margin-left: auto;\n  font-size: 0.75rem;\n}\n\n.cl-check.is-done {\n  cursor: default;\n  border-color: color-mix(in srgb, var(--cl-ok) 35%, var(--cl-line));\n  background: color-mix(in srgb, var(--cl-ok) 6%, transparent);\n}\n\n.cl-validate {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  padding: 0.75rem 0.85rem;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--cl-ok) 40%, var(--cl-line));\n  background: color-mix(in srgb, var(--cl-ok) 7%, transparent);\n  font-size: 0.85rem;\n  line-height: 1.4;\n  cursor: pointer;\n}\n\n.cl-validate input {\n  margin-top: 0.1rem;\n}\n\n.cl-modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 0.25rem;\n}\n\n.cl-btn {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.55rem;\n  padding: 0.55rem 1.1rem;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font: 600 0.85rem/1 var(--cl-body);\n  cursor: pointer;\n  transition: transform 0.18s var(--cl-ease), opacity 0.18s var(--cl-ease);\n}\n\n.cl-btn:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n\n.cl-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.cl-btn--primary {\n  background: var(--cl-pine);\n  color: #fff;\n}\n\n.cl-btn--ghost {\n  background: transparent;\n  border-color: var(--cl-line);\n  color: var(--cl-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
